import type { FunctionComponent } from 'react'

import { COLORS, SPACING } from '@monthio/design-system'
import { Search } from '@monthio/icons'
import { TextInputField, useDebounce } from '@monthio/react-components'
import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const SearchBarContainer = styled.div`
	width: 100%;
	box-sizing: border-box;
	display: flex;
	flex-wrap: nowrap;
	background: ${COLORS.graphics.surface.cardPrimary};
	padding: ${SPACING.xs};
`

const SearchDiv = styled.div`
	display: flex;
	direction: row;
	justify-content: space-between;
	width: 100%;
`
const SearchIconContainer = styled.div`
	align-self: center;
`

export const SearchBar: FunctionComponent<{
	value: string
	onChange: (text: string) => void
}> = ({ value, onChange }) => {
	const { t } = useTranslation()
	const [localValue, setLocalValue] = useState(value)

	const debouncedSetValue = useDebounce(onChange, 300)

	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const newValue = event.target.value
			setLocalValue(newValue)
			debouncedSetValue(newValue)
		},
		[debouncedSetValue],
	)

	return (
		<SearchBarContainer>
			<SearchDiv>
				<TextInputField
					placeholder={t(
						'savingsCapacity-extraordinaryItemsTransactions-search-placeholder',
					)}
					value={localValue}
					onChange={handleChange}
					fullWidth
					InputProps={{ disableUnderline: true }}
				/>
				<SearchIconContainer>
					<Search width={24} height={24} />
				</SearchIconContainer>
			</SearchDiv>
		</SearchBarContainer>
	)
}
